/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Дополнительные материалы</h2>
    <p className={styles.description}>
      <a className={styles.link} href="https://codesandbox.io/s/l8q3rqj6q" target="_blank">
        <img
          className={styles.img}
          src="https://codesandbox.io/static/img/play-codesandbox.svg"
          alt="Edit Selectors with Reselect"
        />
      </a>
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://github.com/reduxjs/reselect" target="_blank">
          Репозиторий reselect
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/6Xwo5mVxDqI" target="_blank">
          Reselect with Redux and React.js
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/_9BDn1QeL4U?t=16m52s" target="_blank">
          Фабрики селекторов
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/yxbe0yoqL38" target="_blank">
          Селекторы - уменьшаем связность кода в React/Redux приложениях
        </a>
      </li>
    </ul>
  </section>
))
